import React from 'react';

const Loader = () => {
  return (
    <div
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className="relative z-40">
        <div className="relative inline-block">
          {/* Blur effect background */}
          <div className="absolute inset-0 bg-gradient-sonic-mirrored animate-gradient rounded-full blur-sm brightness-125"></div>
          
          {/* Gradient border */}
          <div className="relative z-10 p-[1px] rounded-full bg-gradient-sonic-mirrored animate-gradient">
            {/* Loading bar container - Increased width from w-48 to w-96 */}
            <div className="w-96 h-2 bg-background rounded-full overflow-hidden">
              {/* Animated loading bar */}
              <div 
                className="h-full bg-gradient-sonic-mirrored animate-loading-bar" 
                style={{
                  width: '200px',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
